import { useQuery } from '@tanstack/react-query';
import {
  getAllRomeDomains,
  getRomeDomainsPaged,
} from '@services/romeDomainService';

export const useGetRomeDomainsPaged = (query: string) => {
  const enabled = query.length > 2 || query === '*';
  return useQuery({
    queryKey: ['RomeDomainsPaged', query],
    queryFn: () => getRomeDomainsPaged(query),
    enabled,
    refetchOnWindowFocus: false,
  });
};
export const useGetAllRomeDomains = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['RomeDomains'],
    queryFn: () => getAllRomeDomains(),
    enabled,
    refetchOnWindowFocus: false,
  });
};
